<template>
  <div>
    <p>{{ trans('subscription.eventseries.explanation_clusters') }}</p>

    <p>
      {{ trans('series.select_one_of_options') }}:
      <span
        class="fa fa-question-circle-o"
        data-toggle="tooltip"
        :title="trans('series.contact_feedback')"
      />
    </p>

    <!--cluster type-->
    <div class="col-xs-12 form-group">
      <label
        class="control-label col-sm-6 col-lg-3"
        for="select_cluster"
      >{{
        trans('subscription.eventseries.create_per') }}</label>

      <div
        id="select_cluster"
        class="input-group col-sm-6 col-lg-9"
        style="z-index: 0;"
      >
        <input
          id="group"
          v-model="clusterType"
          style="margin-right:5px;"
          type="radio"
          value="group"
          name="cluster_type"
        >
        <label for="group">{{ trans_choice('core.groups',1) }}</label>

        <br>

        <input
          id="name"
          v-model="clusterType"
          style="margin-right:5px;"
          type="radio"
          value="name"
          name="cluster_type"
        >
        <label for="name">{{ trans('lecturerflow.lesson_name') }}</label>

        <br>

        <input
          id="time"
          v-model="clusterType"
          style="margin-right:5px;"
          type="radio"
          value="time"
          name="cluster_type"
        >
        <label for="time">{{ trans('subscription.eventseries.time_format') }}</label>
        <select
          v-show="clusterType === 'time'"
          v-model="type_format"
          value="type_format"
          class="form-control"
          name="type_format"
        >
          <option value="W">
            {{ trans('dates.by_period', { period: trans('dates.week_number') }) }}
          </option>
          <option value="D">
            {{ trans('dates.by_period', { period: trans('dates.day_of_week') }) }}
          </option>
          <option value="D-H-i">
            {{ trans('dates.by_period', { period: trans('dates.day_and_time') }) }}
          </option>
        </select>

        <br>

        <input
          id="count"
          v-model="clusterType"
          style="margin-right:5px;"
          type="radio"
          value="count"
          name="cluster_type"
        >
        <label for="count">{{ trans('core.count') }}</label>
        <input
          v-show="clusterType === 'count'"
          id="select_count"
          v-model="count"
          class="form-control"
          type="number"
          min="1"
        >
      </div>
    </div>
  </div>
</template>

<script>
import FormGroup from './../../lecturer-flow/components/FormGroup.vue'
import QueryDatePicker from '../QueryDatePicker.vue'
import SelectorComponent from '../FormComponents/SelectorComponent.vue'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'CreateEventSeries',
  components: { FormGroup, SelectorComponent, QueryDatePicker },

  computed: {
    clusterType: {
      get () {
        return this.$store.state.eventSerieSubscribables.cluster_type
      },
      set (newValue) {
        this.$emit('canNotFinishStep')
        this.$store.dispatch('change_loading_series', { loading: true }).then(() => {
          this.updateClusterType(newValue)
        })
      },
    },
    count: {
      get () {
        return this.$store.state.eventSerieSubscribables.count
      },
      set (newValue) {
        this.$emit('canNotFinishStep')
        this.$store.dispatch('change_loading_series', { loading: true }).then(() => {
          this.$store.dispatch('delete_subscribables').then(() => {
            this.$store.dispatch('update_count', newValue).then(() => {
              if (newValue != '') {
                this.updateEventSeries()
              } else {
                return this.$store.dispatch('empty_event_series').then(() => {
                  this.$store.dispatch('change_loading_series', { loading: false })
                })
              }
            })
          })
        })
      },
    },
    type_format: {
      get () {
        return this.$store.state.eventSerieSubscribables.type_format
      },
      set (newValue) {
        this.$emit('canNotFinishStep')
        this.$store.dispatch('change_loading_series', { loading: true }).then(() => {
          this.$store.dispatch('delete_subscribables').then(() => {
            this.$store.dispatch('update_type_format', newValue).then(() => {
              if (['W', 'D', 'D-H-i'].indexOf(newValue) > -1) {
                this.updateEventSeries()
              } else {
                return this.$store.dispatch('empty_event_series').then(() => {
                  this.$store.dispatch('change_loading_series', { loading: false })
                })
              }
            })
          })
        })
      },
    },

    courses () {
      return this.$store.state.eventSeries.courses
    },
  },

  methods: {
    updateClusterType (newValue) {
      return this.$store.dispatch('delete_subscribables').then(() => {
        this.$store.dispatch('update_cluster_type', { cluster_type: newValue }).then(() => {
          if (newValue !== 'count' || (this.count != null && this.count !== 0 && this.count !== '')) {
            this.updateEventSeries()
          } else {
            return this.$store.dispatch('empty_event_series').then(() => {
              this.$store.dispatch('change_loading_series', { loading: false })
            })
          }
        })
      })
    },

    updateEventSeries () {
      this.$store.dispatch('get_subscribables_event_series', { course_information: this.$store.state.eventSeries.courses }).then(data => {
        this.$store.dispatch('update_event_series', { data: data.data }).then(data => {
          let eventClusters = Object.values(data.included).filter(included => {
            return included.type === 'event_clusters'
          })
          let subscribableInformation = Object.values(eventClusters).map(cluster => {
            let clusterLabel = cluster.attributes.label
            return {
              id: cluster.id,
              name: clusterLabel != null && clusterLabel !== '' ? clusterLabel : cluster.id,
            }
          })
          return this.$store.dispatch('add_subscribables', { subscribableInformation: subscribableInformation })
        })
        this.$emit('canFinishStep')
        this.$store.dispatch('change_loading_series', { loading: false })
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>

<style>

</style>
